<template>
  <TopGradientBlockLayout>
    <template v-slot:top v-if="!currentUserIsWatcher">
      <BaseButton v-if="!openForm" @click="openForm=true"
                  theme="red"
                  class="w-91">
        {{ $t('createPortfolio') }}
      </BaseButton>
      <InvestmentsSettingsForm v-else/>
    </template>
    <InvestmentsSettingsPortfolioList :list="portfolios_list.data"
                                      @edit="setEditItem"/>
    <transition name="modal">
      <InvestmentsSettingsEditModal v-if="!!edit_portfolio"
                                    :edit_portfolio="edit_portfolio"
                                    @close="edit_portfolio=null"/>
    </transition>

  </TopGradientBlockLayout>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";
import InvestmentsSettingsForm from "@/components/cabinet/SpaceSettings/InvestmentsSettings/InvestmentsSettingsForm";
import InvestmentsSettingsPortfolioList
  from "@/components/cabinet/SpaceSettings/InvestmentsSettings/InvestmentsSettingsPortfolioList";
import InvestmentsSettingsEditModal
  from "@/components/cabinet/SpaceSettings/InvestmentsSettings/InvestmentsSettingsEditModal";

export default {
  name: "InvestmentsSettings",
  components: {
    InvestmentsSettingsEditModal,
    InvestmentsSettingsPortfolioList,
    InvestmentsSettingsForm,
    BaseButton,
    TopGradientBlockLayout,
  },
  data() {
    return {
      openForm: false,
      edit_portfolio: null,
    }
  },
  computed: {
    ...mapState('investments/portfolios', ['portfolios_list']),
    ...mapGetters('space', ['currentUserIsWatcher']),
  },
  methods: {
    setEditItem(val) {
      this.edit_portfolio = val;
    },
    async fetchMainData() {
      try {
        await this.$store.dispatch('investments/portfolios/getPortfolios');
        if (!this.$store.state.investments.brokers.brokers.length) {
          await this.$store.dispatch('investments/brokers/getBrokers')
        }
      } catch (e) {
        throw e;
      }
    },
  },
  async created() {
    await this.fetchMainData();
  },
  i18n: {
    messages: {
      en: {
        createPortfolio: 'Create portfolio'
      },
      ru: {
        createPortfolio: 'Добавить портфель'
      }
    }
  }
}
</script>